module.exports = __webpack_public_path__ + "static/media/drapcode-icon-192x192.98b8dc5a.png";